module.exports = __webpack_public_path__ + "static/media/success-icon.f520a37f.svg";